import BaseModel from "./base/baseModel";

export default class GrupoTelaAcaoModel extends BaseModel {
    id?: number = null;
    grupoId?: number = null;
    grupoDescricao?: string = null;
    telaAcaoId?: number = null;
    telaAcaoDescricao?: string = null;
}
